<template>
  <flash-message />
  <slot />
</template>

<script>
import FlashMessage from '@/Partials/FlashMessage.vue'

export default {
  components: { FlashMessage },
}
</script>
